import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  IClaimData,
  ILotteryData,
  IStakeingData,
  IWhiteListData,
  IBridgeData,
  IUser,
  IAllStakeingData,
} from "../../types/Staking";
import { getMethod, getOracleMethod } from "../../utils/axios";

const getUserStakedInfo = async (wallet: string) => {
  try {
    const data = await getOracleMethod(
      `/api/get-user-data?user_address=${wallet}`
    );
    if (data.status === 200) {
      return data.data;
    }
    return "";
  } catch (exception) {
    console.log("getUserStakedInfo()", exception);
    return "";
  }
};

export const getAllUserStakedInfo = async (wallet: string) => {
  try {
    const data = await getOracleMethod(
      `/api/get-user-staking-info?user_address=${wallet}`
    );
    if (data.status === 200) {
      return data.data;
    }
    return "";
  } catch (exception) {
    console.log("getAllUserStakedInfo()", exception);
    return "";
  }
};

const getKycStatus = async (wallet: string) => {
  try {
    const data = await getMethod(
      `/api/blockpass/kyc-status?walletAddress=${wallet}`
    );
    if (data.data === "No") {
      return "";
    }
    return data.data;
  } catch (exception) {
    console.log("Kyc Exception", exception);
    return "";
  }
};

export const stakeUserData = createAsyncThunk(
  "staking",
  async (wallet: string) => {
    // const amount = await getStakedAmount(wallet);
    // const reward = await getUserReward(wallet);
    // const lastClaim = await getLastClaimedTimestamp(wallet);
    const UserStakedInfo = await getUserStakedInfo(wallet);
    const kycStatus = await getKycStatus(wallet);
    const stakingData: IStakeingData = {
      wallet,
      amountStaked: UserStakedInfo.tokensStakedByAddress,
      amountStakedwithBonus: UserStakedInfo.tokensStakedWithBonusByAddress,
      lastStake: UserStakedInfo.lastClaimedTimestamp,
      accountReward: UserStakedInfo.rewards,
      kycStatus,
    };
    // const stakingData: IStakeingData = {
    //   wallet: wallet,
    //   amountStaked: amount,
    //   lastStake: lastClaim,
    //   accountReward: reward,
    //   kycStatus: kycStatus
    // };

    return stakingData;
  }
);

export const allStakeUserData = createAsyncThunk(
  "all-staking",
  async (wallet: string) => {
    const allUserStakedInfo = await getAllUserStakedInfo(wallet);
    const allStakingData: IAllStakeingData[] = [];
    allUserStakedInfo.forEach((singleStake: IAllStakeingData) => {
      return allStakingData.push({
        // eslint-disable-next-line no-underscore-dangle
        id_: singleStake.id_,
        tokensStaked: singleStake.tokensStaked,
        owner: singleStake.owner,
        stakingTime: singleStake.stakingTime,
        tokensStakedWithBonus: singleStake.tokensStakedWithBonus,
        chain: singleStake.chain,
        timeToUnlock: singleStake.timeToUnlock,
      });
    });
    return allStakingData;
  }
);

// export const getWhitelistByWallet: any = createAsyncThunk(
//   "/api/whitelist/get-whitelist-by-user?walletAddress/wallet",
//   async (wallet: string) => {
//     const data = await getMethod(
//       `/api/project/get-whitelist-by-user?walletAddress=${wallet}`
//     );
//     return data.data;
//   }
// );

export const getClaimByWallet = createAsyncThunk(
  "/api/project/get-claims-by-user?walletAddress/wallet",
  async (wallet: string) => {
    const data = await getMethod(
      `/api/project/get-claims-by-user?walletAddress=${wallet}`
    );
    return data.data;
  }
);
// export const getLotteryByWallet: any = createAsyncThunk(
//   "/api/project/get-lottery-by-user?walletAddress/wallet",
//   async (wallet: string) => {
//     const data = await getMethod(
//       `/api/project/get-lottery-by-user?walletAddress=${wallet}`
//     );
//     return data.data;
//   }
// );
export const getLotteryByWallet = createAsyncThunk(
  "/api/project/get-lottery-details-by-user?walletAddress/wallet",
  async (wallet: string) => {
    const data = await getMethod(
      `/api/project/get-lottery-details-by-user?walletAddress=${wallet}`
    );
    return data.data;
  }
);

// export const getEthBridgeInfoByWallet = createAsyncThunk(
//   "ETH",
//   async (wallet: string) => {
//     const data = await getBridgeInfo(wallet, "ETH");
//     return data;
//   }
// );

// export const getBscBridgeInfoByWallet = createAsyncThunk(
//   "BSC",
//   async (wallet: string) => {
//     const data = await getBridgeInfo(wallet, "BSC");
//     return data;
//   }
// );

type InitialStateType = {
  stakingInfo?: IStakeingData;
  allStakingInfo?: IAllStakeingData[];
  userInfo: IUser | null;
  whitelistInfo: IWhiteListData[];
  lotteryInfo: ILotteryData[];
  claimInfo: IClaimData[];
  EthbridgeInfo: IBridgeData[];
  BscbridgeInfo: IBridgeData[];
  stakingInfoLoader: boolean;
  whitelistLoader: boolean;
  lotteryInfoLoader: boolean;
  claimInfoLoader: boolean;
  EthBridgeInfoLoader: boolean;
  BscBridgeInfoLoader: boolean;
  allStakingInfoLoader: boolean;
};

const initialState: InitialStateType = {
  stakingInfo: undefined,
  userInfo: null,
  whitelistInfo: [],
  lotteryInfo: [],
  claimInfo: [],
  EthbridgeInfo: [],
  BscbridgeInfo: [],
  allStakingInfo: [],
  stakingInfoLoader: false,
  whitelistLoader: false,
  lotteryInfoLoader: false,
  claimInfoLoader: false,
  EthBridgeInfoLoader: false,
  BscBridgeInfoLoader: false,
  allStakingInfoLoader: false,
};

const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {},
  extraReducers: {
    [stakeUserData.pending.toString()]: (state) => {
      state.stakingInfoLoader = true;
    },
    [stakeUserData.fulfilled.toString()]: (state, action) => {
      state.stakingInfoLoader = false;
      state.stakingInfo = action.payload;
    },
    [stakeUserData.rejected.toString()]: (state) => {
      state.stakingInfoLoader = false;
    },
    [allStakeUserData.pending.toString()]: (state) => {
      state.allStakingInfoLoader = true;
    },
    [allStakeUserData.fulfilled.toString()]: (state, action) => {
      state.allStakingInfoLoader = false;
      state.allStakingInfo = action.payload;
    },
    [allStakeUserData.rejected.toString()]: (state) => {
      state.allStakingInfoLoader = false;
    },
    // [getWhitelistByWallet.pending]: (state, action) => {
    //   state.whitelistLoader = true;
    // },
    // [getWhitelistByWallet.fulfilled]: (state, action) => {
    //   state.whitelistLoader = false;
    //   action.payload.forEach((n: any) => {
    //     state.whitelistInfo.push({
    //       projectId: n.projectId,
    //       projectName: n.projectTitle,
    //       whiteListDate: n.createdDate,
    //     });
    //   });
    // },
    // [getWhitelistByWallet.rejected]: (state, action) => {
    //   state.whitelistLoader = false;
    // },
    [getClaimByWallet.pending.toString()]: (state) => {
      state.claimInfoLoader = true;
    },
    [getClaimByWallet.fulfilled.toString()]: (state, action) => {
      state.claimInfoLoader = false;
      state.claimInfo = [];
      action.payload.forEach(
        (n: {
          claimDate: string;
          claimedTickets: number;
          transactionHash: string;
          title: string;
        }) => {
          state.claimInfo.push({
            claimDate: n.claimDate,
            claimAmount: n.claimedTickets,
            txHash: n.transactionHash,
            Title: n.title,
          });
        }
      );
    },

    [getClaimByWallet.rejected.toString()]: (state) => {
      state.claimInfoLoader = false;
    },
    [getLotteryByWallet.pending.toString()]: (state) => {
      state.lotteryInfoLoader = true;
    },
    [getLotteryByWallet.fulfilled.toString()]: (state, action) => {
      state.lotteryInfoLoader = false;
      try {
        state.lotteryInfo = [];
        action.payload.forEach(
          (n: ILotteryData & { projectTitle: string; user: IUser }) => {
            state.lotteryInfo.push({
              projectId: n.projectId,
              projectName: n.projectTitle,
              tickets: n.tickets,
              createdDate: n.createdDate,
              isWhiteListed: n.isWhiteListed,
              whiteListCreated: n.whiteListCreated,
              ticketToTokenMultiplier: n.ticketToTokenMultiplier,
            });
            state.userInfo = n.user;
          }
        );
      } catch {
        state.lotteryInfo.push({
          projectId: 0,
          projectName: "Error",
          tickets: 0,
          createdDate: "Error",
          isWhiteListed: "No",
          whiteListCreated: "Error",
          ticketToTokenMultiplier: 0,
        });
      }
    },
    [getLotteryByWallet.rejected.toString()]: (state) => {
      state.lotteryInfoLoader = false;
    },

    // [getEthBridgeInfoByWallet.pending.toString()]: (state) => {
    //   state.EthBridgeInfoLoader = true;
    // },
    // [getEthBridgeInfoByWallet.fulfilled.toString()]: (state, action) => {
    //   state.EthBridgeInfoLoader = false;
    //   try {
    //     state.EthbridgeInfo = [];
    //     action.payload.forEach((n: IBridgeData) => {
    //       state.EthbridgeInfo.push({
    //         from: n.from,
    //         amount: n.amount,
    //         txHash: n.txHash,
    //         timestamp: n.timestamp,
    //       });
    //     });
    //   } catch {
    //     state.EthbridgeInfo.push({
    //       from: "",
    //       amount: 0,
    //       txHash: "",
    //       timestamp: 0,
    //     });
    //   }
    // },
    // [getEthBridgeInfoByWallet.rejected.toString()]: (state) => {
    //   state.EthBridgeInfoLoader = false;
    // },

    // [getBscBridgeInfoByWallet.pending.toString()]: (state) => {
    //   state.BscBridgeInfoLoader = true;
    // },
    // [getBscBridgeInfoByWallet.fulfilled.toString()]: (state, action) => {
    //   state.BscBridgeInfoLoader = false;
    //   try {
    //     state.BscbridgeInfo = [];
    //     action.payload.forEach((n: IBridgeData) => {
    //       state.BscbridgeInfo.push({
    //         from: n.from,
    //         amount: n.amount,
    //         txHash: n.txHash,
    //         timestamp: n.timestamp,
    //       });
    //     });
    //   } catch {
    //     state.BscbridgeInfo.push({
    //       from: "",
    //       amount: 0,
    //       txHash: "",
    //       timestamp: 0,
    //     });
    //   }
    // },
    // [getBscBridgeInfoByWallet.rejected.toString()]: (state) => {
    //   state.BscBridgeInfoLoader = false;
    // },
  },
});

// eslint-disable-next-line no-empty-pattern
export const {} = homePageSlice.actions;

export default homePageSlice.reducer;
